module.exports = __webpack_public_path__ + "img/fin-yritysrahoitus.b982b3f4.png";